import { VALID_CONTEXTUAL_SECTION_IDS } from '@agentbrush/shared';

export type ValidSectionId = (typeof VALID_CONTEXTUAL_SECTION_IDS)[number];

export interface ContextualStep {
  targetSelector: string;
  titleKey: string;
  descriptionKey: string;
}

export interface ContextualSection {
  sectionId: ValidSectionId;
  steps: ContextualStep[];
}

export const CONTEXTUAL_SECTIONS: ContextualSection[] = [
  {
    sectionId: 'dashboard',
    steps: [
      {
        targetSelector: '[data-onboarding="dashboard-plan"]',
        titleKey: 'contextual.dashboard_plan_title',
        descriptionKey: 'contextual.dashboard_plan_description',
      },
      {
        targetSelector: '[data-onboarding="dashboard-usage"]',
        titleKey: 'contextual.dashboard_usage_title',
        descriptionKey: 'contextual.dashboard_usage_description',
      },
    ],
  },
  {
    sectionId: 'billing',
    steps: [
      {
        targetSelector: '[data-onboarding="billing-plan"]',
        titleKey: 'contextual.billing_plan_title',
        descriptionKey: 'contextual.billing_plan_description',
      },
    ],
  },
  {
    sectionId: 'settings',
    steps: [
      {
        targetSelector: '[data-onboarding="settings-apikeys"]',
        titleKey: 'contextual.settings_apikeys_title',
        descriptionKey: 'contextual.settings_apikeys_description',
      },
    ],
  },
];

export { VALID_CONTEXTUAL_SECTION_IDS as VALID_SECTION_IDS } from '@agentbrush/shared';
